<template>
  <div
    v-click-outside="hideMenu"
    class="hamburger-menu-wrapper"
  >
    <i
      class="fa fa-bars hamburger-icon"
      @click="toggleMenu"
    />
    <div
      v-if="showMenu"
      class="menu-overlay"
      @click="hideMenu"
    />
    <ul
      v-if="showMenu"
      class="hamburger-dropdown"
      @click.stop
    >
      <li
        class="option"
        :class="{ selected: isSelected('rallyhood') }"
        @click="navigateTo('rallies')"
      >
        My Rallyhood
      </li>
      <li
        class="option"
        :class="{ selected: isSelected('calendar') }"
        @click="navigateTo('calendar')"
      >
        My Calendar
      </li>
      <!--
      <li class="my-events-group">
        <div
          class="option option--expandable"
          :class="{ selected: isMyEventsSectionActive }"
          role="button"
          tabindex="0"
          @click.stop="toggleMyEventsExpanded"
          @keydown.enter.prevent="toggleMyEventsExpanded"
          @keydown.space.prevent="toggleMyEventsExpanded"
        >
          <span>My Events</span>
          <i
            class="fa expand-chevron"
            :class="myEventsExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"
            aria-hidden="true"
          ></i>
        </div>
        <ul v-show="myEventsExpanded" class="hamburger-submenu">
          <li
            class="option option--sub"
            :class="{ selected: isMyEventsSubSelected('manage') }"
            @click="navigateToMyEventsSub('manage')"
          >
            Manage My Events
          </li>
          <li
            class="option option--sub"
            :class="{ selected: isMyEventsSubSelected('attending') }"
            @click="navigateToMyEventsSub('attending')"
          >
            Attending
          </li>
          <li
            class="option option--sub"
            :class="{ selected: isMyEventsSubSelected('upcoming') }"
            @click="navigateToMyEventsSub('upcoming')"
          >
            Upcoming
          </li>
          <li
            class="option option--sub"
            :class="{ selected: isMyEventsSubSelected('archived') }"
            @click="navigateToMyEventsSub('archived')"
          >
            Archived
          </li>
        </ul>
      </li>
      -->
      <li
        class="option"
        :class="{ selected: isSelected('messaging') }"
        @click="navigateTo('messaging')"
      >
        Messaging
      </li>
      <li
        class="option"
        :class="{ selected: isSelected('activity') }"
        @click="navigateTo('activity')"
      >
        Activity
      </li>
    </ul>
  </div>
</template>

<script>
import { router } from "../common";

export default {
  name: "HamburgerMenu",
  data() {
    return {
      showMenu: false,
      myEventsExpanded: false,
    };
  },
  computed: {
    isMyEventsSectionActive() {
      const path = this.$route?.path || "";
      if (path === "/my-events" || path.startsWith("/my-events/")) return true;
      if (path === "/events" || path.startsWith("/events/")) return true;
      return false;
    },
  },
  watch: {
    $route() {
      this.syncMyEventsExpandedToRoute();
    },
  },
  methods: {
    isSelected(route) {
      const path = this.$route?.path || "";
      if (route === "rallyhood") return path === "/rallies" || path.startsWith("/rallies");
      if (route === "calendar") return path === "/calendar" || path.startsWith("/calendar");
      if (route === "messaging") return path === "/messaging" || path.startsWith("/messaging");
      if (route === "activity") return path === "/feed" || path.startsWith("/feed");
      return false;
    },
    isMyEventsSubSelected(type) {
      const path = this.$route?.path || "";
      const filter = this.$route?.query?.filter;
      switch (type) {
        case "manage":
          return path === "/events" || path.startsWith("/events/");
        case "attending":
          return path === "/my-events" && filter === "attending";
        case "upcoming":
          return path === "/my-events" && filter === "upcoming";
        case "archived":
          return path === "/my-events" && filter === "archived";
        default:
          return false;
      }
    },
    syncMyEventsExpandedToRoute() {
      this.myEventsExpanded = this.isMyEventsSectionActive;
    },
    toggleMyEventsExpanded() {
      this.myEventsExpanded = !this.myEventsExpanded;
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
      if (this.showMenu) {
        this.syncMyEventsExpandedToRoute();
      }
    },
    hideMenu() {
      this.showMenu = false;
      this.myEventsExpanded = false;
    },
    navigateTo(route) {
      this.showMenu = false;
      this.myEventsExpanded = false;
      switch (route) {
        case "rallyhood":
          router.push("/rallies");
          break;
        case "calendar":
          router.push("/calendar");
          break;
        case "messaging":
          router.push("/messaging");
          break;
        case "activity":
          router.push("/feed");
          break;
        default:
          router.push("/rallies");
      }
    },
    navigateToMyEventsSub(type) {
      this.showMenu = false;
      this.myEventsExpanded = false;
      switch (type) {
        case "manage":
          router.push("/events?filter=manage");
          break;
        case "attending":
          router.push("/my-events?filter=attending");
          break;
        case "upcoming":
          router.push("/my-events?filter=upcoming");
          break;
        case "archived":
          router.push("/my-events?filter=archived");
          break;
        default:
          router.push("/events");
      }
    },
  },
};
</script>

<style scoped>
  .hamburger-menu-wrapper {
    position: relative;
    cursor: pointer;
  }

  .hamburger-icon {
    font-size: 20px;
    color: #006471;
  }

  .menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: transparent;
    z-index: 100;
  }

  @media (max-width: 960px) {
    .menu-overlay {
      background-color: rgba(51, 51, 51, 0.75);
    }
  }

  .hamburger-dropdown {
    background-color: white;
    z-index: 101;
    position: fixed;
    top: 71.03px;
    left: 16px;
    min-width: 200px;
    border-radius: 5px;
    box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.08);
    list-style: none;
    padding: 0;

    .option {
      display: flex;
      align-items: center;
      padding: 12px 16px;
      cursor: pointer;
      color: #333333;
      font-size: 14px;
      text-align: left;
      font-family: "Lato", sans-serif;
    }

    .option:hover {
      background-color: #f5f5f5;
      color: #333333 !important;
    }

    .option.selected {
      font-weight: 700;
    }
  }

  @media (max-width: 768px) {
    .hamburger-dropdown {
      left: 8px;
      right: 8px;

      .option {
        font-size: 16px !important;
        padding: 10px 24px !important;
      }
      .option--sub {
        padding: 10px 24px 10px 40px !important;
      }
    }
  }

  .hamburger-dropdown > li.option:first-child {
    border-radius: 5px 5px 0 0;
  }

  .hamburger-dropdown > li.option:last-child {
    border-radius: 0 0 5px 5px;
  }

  .my-events-group {
    list-style: none;
  }

  .option--expandable {
    justify-content: space-between;
    gap: 8px;
  }

  .expand-chevron {
    font-size: 12px;
    color: #006471;
    flex-shrink: 0;
  }

  .hamburger-submenu {
    list-style: none;
    padding: 0;
    margin: 0;
    background-color: #ffffff;
  }

  .option--sub {
    padding: 12px 16px 12px 36px;
    font-size: 14px;
  }
</style>
